import React from "react";
import Property from "assets/property.png";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";

// form & validsation
import * as yup from "yup";
import { FormError, FormRadio, FormLabel, FormInput } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import { Button } from "components/Basic/Button";

// schema
const schema = yup.object().shape({
  financial: yup
    .object()
    .shape({
      if_real_estate: yup.string().required("You must provide a value"),
      real_estate_details: yup.object().shape({
        ownership: yup.string().required("You must provide a value"),
        value: yup.string().required("You must provide a value"),
        mortgage: yup.string().required("You must provide a value"),
      }),
    })
    .required(),
});

export function Step08({ onSubmit, store }) {
  const [realEstate, setRealEstate] = React.useState(
    store.financial.real_estate_details || []
  );
  const [ifRealEstate, setIfRealEstate] = React.useState(
    store.financial.if_real_estate || ""
  );

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  const handleData = () => {
    if (realEstate.length) {
      const merger_current_values = {
        ...store.financial,
        real_estate_details: realEstate,
        if_real_estate: ifRealEstate,
      };
      const mergeToStore = { ...store, financial: merger_current_values };
      onSubmit(mergeToStore);
    } else {
      const merger_current_values = {
        ...store.financial,
        real_estate_details: [],
        if_real_estate: watch()?.financial?.if_real_estate,
      };
      const mergeToStore = { ...store, financial: merger_current_values };
      onSubmit(mergeToStore);
    }
  };

  const addProperty = (values) => {
    setIfRealEstate(values.financial.if_real_estate);
    setRealEstate([...realEstate, values.financial.real_estate_details]);
    setValue("financial.real_estate_details.ownership", "", {
      shouldValidate: true,
    });
    setValue("financial.real_estate_details.value", "", {
      shouldValidate: true,
    });
    setValue("financial.real_estate_details.mortgage", "", {
      shouldValidate: true,
    });
  };

  const removeProperty = (index) => {
    const copydata = realEstate.slice();
    copydata.splice(index, 1);
    setRealEstate(copydata);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(addProperty)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.if_real_estate"
            className={customClasses.questionText}
            error={errors?.financial?.if_real_estate?.message}
          >
            Did either you or{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}{" "}
            own any real estate?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_real_estate"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_real_estate"
              register={register}
            />
          </article>
        </section>

        {watch()?.financial?.if_real_estate.match(/yes/i) ? (
          <p className="text-center text-xl font-bold my-5">
            Add all the real estate below
          </p>
        ) : null}

        {watch()?.financial?.if_real_estate.match(/yes/i) ? (
          <>
            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`financial.real_estate_details.ownership`}
                className={customClasses.questionText}
                error={
                  errors?.financial?.real_estate_detailsd?.ownership?.message
                }
              >
                How is this property owned?
              </FormLabel>
              <article>
                <FormInput
                  placeholder="Type here"
                  id={`financial.real_estate_details.ownership`}
                  type="text"
                  name={`financial.real_estate_details.ownership`}
                  error={
                    errors?.financial?.real_estate_detailsd?.ownership?.message
                  }
                  register={register}
                />
              </article>
            </section>

            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`financial.real_estate_details.value`}
                className={customClasses.questionText}
                error={errors?.financial?.real_estate_detailsd?.value?.message}
              >
                What is the approx. value?
              </FormLabel>
              <article>
                <FormInput
                  placeholder="When do you start living together"
                  id={`financial.real_estate_details.value`}
                  type="text"
                  name={`financial.real_estate_details.value`}
                  error={
                    errors?.financial?.real_estate_detailsd?.value?.message
                  }
                  register={register}
                />
              </article>
            </section>

            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`financial.real_estate_details.mortgage`}
                className={customClasses.questionText}
                error={
                  errors?.financial?.real_estate_detailsd?.mortgage?.message
                }
              >
                What is the approx. mortgage?
              </FormLabel>
              <article>
                <FormInput
                  placeholder="When do you start living together"
                  id={`financial.real_estate_details.mortgage`}
                  type="text"
                  name={`financial.real_estate_details.mortgage`}
                  error={
                    errors?.financial?.real_estate_detailsd?.mortgage?.message
                  }
                  register={register}
                />
              </article>
            </section>
          </>
        ) : null}

        {watch()?.financial?.if_real_estate.match(/yes/i) ? (
          <Button
            bgColor="bg-gray-300"
            className="text-xl font-bold px-10 py-3 mb-10 m-auto block"
            textColor="black"
            borderColor="native-300"
            borderWidth="border-2"
            type="submit"
            form="divorce-form"
          >
            + Add Property
          </Button>
        ) : null}

        <section>
          {realEstate?.length
            ? realEstate?.map(
                (d, i) =>
                  d.ownership && (
                    <>
                      <div
                        key={i}
                        className="shadow-xl rounded-md border border-gray-100 mt-2 py-3 bg-white flex justify-between items-center px-2 relative"
                      >
                        <div>
                          <img src={Property} className="w-16" alt="child" />
                        </div>
                        <div className="absolute left-20">
                          <div>
                            <b>Ownership</b>: {d.ownership}
                          </div>
                          <div>
                            <b>Value</b>: {d.value}
                          </div>
                          <div>
                            <b>Mortgage</b>: {d.mortgage}
                          </div>
                        </div>
                        <div
                          className="w-7 h-7 rounded-full bg-red-500 flex justify-center items-center cursor-pointer"
                          onClick={() => removeProperty(i)}
                        >
                          <CloseIcon className="text-white" />
                        </div>
                      </div>
                    </>
                  )
              )
            : null}
        </section>
        {watch()?.financial?.if_real_estate.match(/yes/i) ? (
          <section className="flex justify-center mt-10	">
            <WarningIcon fontSize="large" />
            <p className="text-center text-lg ml-5 italic">
              Please add all real estate before continuing. Click the button
              above to add each property separately
            </p>
          </section>
        ) : null}

        <Button
          bgColor={
            watch()?.financial.if_real_estate === "No"
              ? "bg-native-300"
              : watch()?.financial.if_real_estate === "Yes" &&
                !realEstate.length
              ? "bg-gray-100"
              : "bg-native-300"
          }
          disabled={
            watch()?.financial.if_real_estate === "No"
              ? false
              : watch()?.financial.if_real_estate === "Yes" &&
                !realEstate.length
              ? true
              : false
          }
          onClick={handleData}
          fontSize="lg"
          form="divorce-form"
          className="w-32 m-auto block p-2 py-1 mt-6 focus:outline-none hover:bg-native-300  hover:border-native-300"
        >
          Next
        </Button>
      </section>
    </form>
  );
}
